import React from 'react';
import { graphql, StaticQuery, Link } from 'gatsby';

import './headlines.css';

const HeadlinesSide = (props) => {
	const headlineCount = props.count ?? 3;
	const excludeIds = props.exclude ?? [];

	const query = graphql`
		query HeadlinesQuery {
		  allMarkdownRemark(
			filter: {fields: {source: {eq: "content"}}, frontmatter: {type: {eq: "blog"}, description: {ne: null}, heroimage: {ne: null}}}
			sort: {frontmatter: {date: DESC}}
		  ) {
			nodes {
			  frontmatter {
				title
				description
				tags
				date
				heroimage
				interact
			  }
			  fields {
				slug
			  }
			  id
			}
		  }
		}
	`;

	const renderHeadlines = ({ allMarkdownRemark: { nodes }}) => {
		const dtNow = new Date();
		const allblogs = nodes.filter(node => {
			if (excludeIds.includes(node.id)) return false;
			if (!node.frontmatter.interact || !node.frontmatter.interact.includes('featured=1')) return false;
			const dtHeadline = new Date(node.frontmatter.date);
			return (props.series === '' || node.frontmatter.tags?.includes(props.series))
				&& dtHeadline < dtNow;
		});
		const headlines = allblogs.length > headlineCount ? allblogs.slice(0, headlineCount) : allblogs;

		if (headlines.length === 0)
			return (<></>);

		return (
			<aside className='headlines'>
				<h2>{props.heading ?? 'Latest Headlines'}</h2>
				{headlines.map(node => (
					<div key={node.fields.slug} className='headline'>
						<div className='thumb'>
							<img src={node.frontmatter.heroimage} alt={node.frontmatter.title} />
						</div>
						<div className='story'>
							<b><Link to={node.fields.slug}>{node.frontmatter.title}</Link></b>
							<br /><span className='description'>{node.frontmatter.description}</span>
						</div>
					</div>
				))}
			</aside>
		);
	};

	return (
		<StaticQuery query={query} render={renderHeadlines} />
	);
}

export default HeadlinesSide;
